import { useEffect, useMemo, useRef } from "react";
import FilterHeader from "./FilterHeader";
import FilterPanel from "./FilterPanel";
import WidgetComponent from "../WidgetComponent";

import { useStatisticContext } from "../contexts/StatisticContext";

const StatsApp = () => {
  const { appName, widgetList, showHideFilter, encryptPayload, aggregatedCVAppCount } = useStatisticContext();
  const host = window.REACT_APP_KNOWI_HOST;
  const widgetWrapperRef = useRef(null);

  // widgetList and encryptPayload change only on Apply (or initial load), so the widgets keep
  // rendering the previously applied app while the dropdown selection is still pending.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const appliedAppName = useMemo(() => appName, [widgetList, JSON.stringify(encryptPayload)]);

  useEffect(() => {
    if (widgetWrapperRef.current) {
      widgetWrapperRef.current.scrollTop = 0;
    }
  }, [appName]);

  return (
    <div className="parentContainer">
      <FilterPanel />
      <div className="graphFilterWrapper">
        <FilterHeader />
        <div className="widgetWrapper" ref={widgetWrapperRef}>
          <img src={`${host}w/123`} hidden alt="host_url" />
          {encryptPayload?.tagIdList?.length > 0 && (
            <WidgetComponent
              widgetList={widgetList}
              showHideFilter={showHideFilter}
              encryptPayload={encryptPayload}
              aggregatedCVAppCount={aggregatedCVAppCount}
              selectedCVAppName={appliedAppName}
              cvAppImageName={appliedAppName}
              renderedFrom={"Statistics"}
            ></WidgetComponent>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatsApp;
